import { render, staticRenderFns } from "./TodoSection.vue?vue&type=template&id=ec83c668&"
import script from "./TodoSection.vue?vue&type=script&lang=js&"
export * from "./TodoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports